/* eslint-disable react/prop-types */
import React from 'react';
import { SmsFailed } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const EmptyTable = ({ text }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 2,
        color: 'text.secondary',
      }}
    >
      <SmsFailed sx={{ fontSize: 100, color: 'error.main', mb: 1 }} />
      <Typography variant="h5">{text}</Typography>
    </Box>
  );
};
